import type {Content} from '@prismicio/client'
import {isFilled} from '@prismicio/client'
import type {FC} from 'react'
import {Container} from 'src/common/Container'
import {DEFAULT_PADDING, PADDING_BOTTOM_CLASS_OVERRIDE, PADDING_TOP_CLASS_OVERRIDE} from 'src/common/paddingClasses'
import {BentoGridHeader} from '../components/BentoGridHeader'
import {IconCard} from '../components/IconCard'

type IconCardsVariationProps = {
  slice: Content.BentoGridSliceIconCards
}

/**
 * IconCards variation of BentoGrid
 * Features simplified cards with icons, titles, and descriptions
 */
export const BentoGridIconCardsVariation: FC<IconCardsVariationProps> = ({slice}) => {
  const {tag, heading, cards, background_mode, padding_top, padding_bottom} = slice.primary
  const isDark = background_mode === 'Dark mode'
  const paddingTopClass = PADDING_TOP_CLASS_OVERRIDE[padding_top ?? DEFAULT_PADDING] ?? ''
  const paddingBottomClass = PADDING_BOTTOM_CLASS_OVERRIDE[padding_bottom ?? DEFAULT_PADDING] ?? ''

  return (
    <Container
      data-slice-type="bento_grid"
      data-slice-variation="iconCards"
      className={`flex flex-col items-center px-5 md:px-10 lg:px-5 xl:px-0 ${paddingTopClass} ${paddingBottomClass}`}
      backgroundColor={isDark ? 'Dark Green' : 'Grey/100'}
    >
      <div className="mx-auto w-full max-w-[1200px]">
        <BentoGridHeader tag={tag} heading={heading} isDark={isDark} />

        {/* Cards Grid */}
        {isFilled.group(cards) && (
          <div className="grid grid-cols-1 gap-6 lg:grid-cols-3">
            {cards.map((card, index) => {
              // Use a stable key based on card content or fallback to index
              const titleNode = isFilled.richText(card.title) ? card.title[0] : null
              const titleText = titleNode && typeof titleNode === 'object' && 'text' in titleNode ? titleNode.text : ''
              const key = titleText ? `${titleText}-${index}` : `card-${index}`

              return <IconCard key={key} card={card} isDark={isDark} />
            })}
          </div>
        )}
      </div>
    </Container>
  )
}
